import React, { FC, ReactNode } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';

interface PageWrapperProps {
    title: string;
    description?: string;
    children: ReactNode;
}

const PageWrapper: FC<PageWrapperProps> = ({ title, description, children }) => {
    const isMobile = useMediaQuery('(max-width: 768px)');

    return (
        <Box>
            <Typography variant='h1' sx={{ marginBottom: '16px', fontSize: isMobile ? '24px' : undefined }}>
                {title}
            </Typography>

            {description && (
                <Typography
                    sx={{
                        marginBottom: '16px',
                        fontSize: isMobile ? '14px' : '24px',
                        lineHeight: isMobile ? '20px' : '32px',
                    }}
                >
                    {description}
                </Typography>
            )}
            {children}
        </Box>
    );
};

export default PageWrapper;
